module.exports = __webpack_public_path__ + "img/receipt6.9149b6b8.png";